import React, { useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import ButtonComponent from "../../../../components/common/button/Button";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { toast } from 'react-toastify';
import TopSection from "../../../LT/TopSection";
import AddReasonCodeModal from "../AddReasonCodeModal";
import { useDispatch, useSelector } from "react-redux";
import { deleteReasonCodeEndpoint, getReasonCodeEndpoint, postReasonCodeEndpoint, putEditReasonCodeEndpoint } from "../../../../common/endpoints";
import { getReasonCodeSlice } from "../../../../redux/actions/getReasonCodeSlice";
import { deleteReasonCodeSlice } from "../../../../redux/actions/deleteReasonCodeSlice";
import { putEditReasonCodeSlice } from "../../../../redux/actions/putEditReasonCodeSlice";
import { postReasonCodeSlice } from "../../../../redux/actions/postReasonCodeSlice";
import { DeleteReasonCodeModal } from "../DeleteReasonCodeModal";
import { Loader } from "../../../../components/common/Loader";

const AdminManageReason = () => {
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState();
    const [rowData, setRowData] = useState([]);
    const [openAddReasonCodesModal, setOpenAddReasonCodesModal] = useState(false);
    const [openDeleteConfirmationModalData, setOpenDeleteConfirmationModalData] = useState(false);
    const [selectedDeleteRowItem, setSelectedDeleteRowItem] = useState({});
    const [editModeData, setEditModeData] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [nextReasonCode, setNextReasonCode] = useState()
    const loggedInUserEmail = localStorage.getItem("userEmail");
    const dispatch = useDispatch();
    const selector = useSelector((state) => state.getReasonCodeSlice)
    
    const pagination = true;
    const paginationPageSize = 500;
    const paginationPageSizeSelector = [10, 50, 100, 500, 1000];

    const onGridReady = (params) => {
        setGridApi(params?.api);
        gridRef.current = params.api;
    };

    const gridOptions = {
        getRowId: (params) => {
            return `${params?.data?.reasonCode}`;
        },
    };

    const defaultColDef = useMemo(
        () => ({
            sortable: true,
            filter: "agMultiColumnFilter",
        }),
        []
    );

    const onClickDeleteLineItem = async (item) => {
        setOpenDeleteConfirmationModalData(true);
        setSelectedDeleteRowItem(item)
    }

    const onClickEditExistingRecords = (rowData) => {
        setIsEditMode(true);
        setOpenAddReasonCodesModal(true);
        setEditModeData(rowData);
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteConfirmationModalData(false);
        setSelectedDeleteRowItem({})
    }

    const handleDeleteConfirmation = async () => {
        const item = selectedDeleteRowItem;

        try {
            const responseDeleteSupplier = await dispatch(deleteReasonCodeSlice({
                dynamicEndpoint: `${deleteReasonCodeEndpoint}/${item.data.reasonCode}`,
            }));
            if (responseDeleteSupplier?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseDeleteSupplier?.payload, {
                    autoClose: 2000,
                });
                setOpenDeleteConfirmationModalData(false);
                getReasonCodeList();
            }
            else {
                toast.error(responseDeleteSupplier?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }

    }

    const columns = [
        {
            field: "reasonCode",
            headerName: "Reason Code",
            flex: 1,
        },
        {
            field: "description",   // must match API key
            headerName: "Reason Name",
            flex: 2,
        },
        {
            field: "actions",
            headerName: "Actions",
            cellRenderer: (response) => (
                <div className="btn-wrapper" style={{ marginTop: 6, gap: 30 }} >
                    <EditIcon title="edit" onClick={() => (response?.data?.userEmail !== loggedInUserEmail) && onClickEditExistingRecords(response.data)} style={{ cursor: response?.data?.userEmail !== loggedInUserEmail ? 'pointer' : 'text', marginRight: 20, color: response?.data?.userEmail !== loggedInUserEmail ? '#000' : '#bcbcbc' }} />
                    <DeleteIcon onClick={() => (response?.data?.userEmail !== loggedInUserEmail) && onClickDeleteLineItem(response)} style={{ cursor: response?.data?.userEmail !== loggedInUserEmail ? 'pointer' : 'text', marginRight: 20, color: response?.data?.userEmail !== loggedInUserEmail ? '#000' : '#bcbcbc' }} />
                </div>
            ),
            pinned: 'right',
            lockPinned: true,
            lockPosition: true
        }
    ];

    const getReasonCodeList = async () => {
        try {
            const response = await dispatch(
                getReasonCodeSlice({
                    dynamicEndpoint: getReasonCodeEndpoint,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {
                const list = response?.payload?.reasonCodeList;
                const formattedData = list.map((item) => ({
                    reasonCode: item.reasonCode,
                    description: item.description,
                }));

                setNextReasonCode(response?.payload?.nextReasonCode)
                setRowData(formattedData);
            }
        } catch (error) {
            console.error("Reason Code API error:", error);
        }
    };

    const handleUpdateEditDetailsModal = async (rows) => {
        const updatedRow = rows[0];

        const editListRequestBody = {
            "reasonCode": updatedRow.reasonCode,
            "description": updatedRow.description,
            "active": true
        }
        try {
            const responseInviteSupplier = await dispatch(putEditReasonCodeSlice({
                dynamicEndpoint: putEditReasonCodeEndpoint,
                data: editListRequestBody,
            }));

            if (responseInviteSupplier?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseInviteSupplier?.payload, {
                    autoClose: 2000,
                });
                handleCloseAddReasonCodesModal();
                getReasonCodeList();
            }
            else {
                toast.error(responseInviteSupplier?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    const handleSubmitAddReasonCodesModal = async (rows) => {
        const addReasonData = rows.map(row => ({
            reasonCode: Number(row.reasonCode), // ensure it's a number
            description: row.description || "", // map description -> reasonDescription
            active: row.active !== undefined ? row.active : true
        }));

        const inviteListRequestBody = {
            userEmail: loggedInUserEmail,
            reasonCodeList: addReasonData
        };
        try {
            const responseInviteSupplier = await dispatch(postReasonCodeSlice({
                dynamicEndpoint: postReasonCodeEndpoint,
                data: inviteListRequestBody,
            }));

            if (responseInviteSupplier?.meta?.requestStatus === 'fulfilled') {
                toast.success(responseInviteSupplier?.payload, {
                    autoClose: 2000,
                });
                handleCloseAddReasonCodesModal();
                getReasonCodeList();
            }
            else {
                toast.error(responseInviteSupplier?.payload?.errorMessage, {
                    autoClose: 2000,
                });
            }
        } catch (error) {
            console.error('API error:', error);
        }
    }

    useEffect(() => {
        getReasonCodeList();
    }, []);

    const onClickAddReasonCodes = () => {
        setOpenAddReasonCodesModal(true)
    }

    const handleCloseAddReasonCodesModal = () => {
        setOpenAddReasonCodesModal(false);
        setIsEditMode(false);
        setEditModeData([])
    }

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Admin" },
                ]}
                tabTitle="Manage Reason Codes"
            />
            <div>
                {selector.loading ?
                    <Loader /> : <>
                        <div style={{ display: 'flex', justifyContent: 'end', marginRight: 20, marginTop: -50 }}>
                            <ButtonComponent
                                type="secondary"
                                maxWidth="200px"
                                label="+ Add Reason Code"
                                height="40px"
                                onClick={onClickAddReasonCodes}
                            />
                        </div>

                        <div style={{ margin: "10px 0px" }}>
                            <div className="ag-theme-quartz" style={{ height: 400, width: "100%" }}>
                                {selector.loading ?
                                    <Loader />
                                    :
                                    <AgGridReact
                                        ref={gridRef}
                                        rowData={rowData}
                                        columnDefs={columns}
                                        onGridReady={onGridReady}
                                        gridOptions={gridOptions}
                                        defaultColDef={defaultColDef}
                                        pagination={pagination}
                                        paginationPageSize={paginationPageSize}
                                        paginationPageSizeSelector={paginationPageSizeSelector}
                                    />}
                            </div>
                            <DeleteReasonCodeModal
                                openDeleteConfirmationModalData={openDeleteConfirmationModalData}
                                handleCloseDeleteModal={handleCloseDeleteModal}
                                handleDeleteConfirmation={handleDeleteConfirmation}
                            />
                            <AddReasonCodeModal
                                openAddReasonCodesModal={openAddReasonCodesModal}
                                handleCloseAddReasonCodesModal={handleCloseAddReasonCodesModal}
                                isEditMode={isEditMode}
                                editModeData={editModeData}
                                handleSubmitAddReasonCodesModal={handleSubmitAddReasonCodesModal}
                                handleUpdateEditDetailsModal={handleUpdateEditDetailsModal}
                                rowData={rowData}
                                nextReasonCode={nextReasonCode}
                            />
                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default AdminManageReason;
